import React from 'react';
import { FileUploadEvidenceContentType } from './helpers';
import { ReportFileUploadedEvidence } from './ReportFileUploadedEvidence';
import {
  Evidence,
  EvidenceCard,
  EvidenceIcon,
  EvidenceVerticalLine,
} from './ReportingReport.styles';
import { ReportTextEvidence } from './ReportTextEvidence';

interface ReportEvidenceProps {
  evidenceTitle: string;
  evidenceContent: string | FileUploadEvidenceContentType[];
  evidenceAudio?: React.ReactNode;
  firstEvidence?: boolean;
  lastEvidence?: boolean;
  isFileUploadEnabled?: boolean;
  isReporterViewEvidenceDisabled?: boolean;
  reportId?: string;
  step: number;
  'data-testid'?: string;
}

const hideEvidenceContent = (props: { evidenceContent?: string }) => {
  return (
    !props.evidenceContent ||
    props.evidenceContent === 'undefined' ||
    props.evidenceContent === ''
  );
};

export const ReportEvidence = ({
  evidenceTitle,
  evidenceContent,
  firstEvidence,
  lastEvidence,
  step,
  reportId,
  'data-testid': dataTestId,
  isReporterViewEvidenceDisabled,
}: ReportEvidenceProps) => {
  const isFileUploadQuestion = typeof evidenceContent !== 'string';
  const hasFilesUploaded = Boolean(
    isFileUploadQuestion && evidenceContent && evidenceContent.length > 0,
  );

  return (
    <Evidence>
      <EvidenceIcon firstEvidence={firstEvidence || false}>
        <div>
          <div>{step}</div>
        </div>
        {!lastEvidence && <EvidenceVerticalLine />}
      </EvidenceIcon>

      <EvidenceCard
        data-testid={`evidence-timeline/${evidenceTitle}`}
        noPadding={isFileUploadQuestion && hasFilesUploaded}
      >
        {typeof evidenceContent === 'string' ? (
          <ReportTextEvidence
            evidenceTitle={evidenceTitle}
            evidenceContent={evidenceContent}
            hideEvidenceContent={hideEvidenceContent}
            data-testid={dataTestId}
          />
        ) : (
          <ReportFileUploadedEvidence
            evidenceContent={evidenceContent || []}
            evidenceTitle={evidenceTitle}
            reportId={reportId}
            data-testid={dataTestId || `evidence-timeline/file-upload-evidence`}
            isReporterViewEvidenceDisabled={isReporterViewEvidenceDisabled}
          />
        )}
      </EvidenceCard>
    </Evidence>
  );
};
